// src/components/ui/Input.tsx
import React from "react";

export interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
  labelClassName?: string;
}

const Input: React.FC<InputProps> = ({
  id,
  label,
  error,
  className = "",
  labelClassName = "",
  ...props
}) => (
  <div className="w-full">
    {label && (
      <label
        htmlFor={id}
        className={[
          "block font-body text-sm font-medium text-slate-900",
          labelClassName
        ].join(" ")}
      >
        {label}
      </label>
    )}

    <div className="mt-2 border-b border-black">
      <input
        id={id}
        className={[
          "w-full bg-transparent py-2",
          "font-body text-base text-slate-900",
          "outline-none",
          "placeholder:text-slate-400",
          "disabled:opacity-100",
          className
        ].join(" ")}
        {...props}
      />
    </div>

    {error && <p className="mt-2 text-xs text-rose-600 font-body">{error}</p>}
  </div>
);

export default Input;
